import { fork, all } from 'redux-saga/effects';
import miscSaga from '@app-redux/sagas/miscSaga';

export default function* rootSaga() {
  yield all([fork(miscSaga)]);
}
